import styled from 'styled-components';

export const StyledLabelRequiredSymbol = styled.span`
    color: var(--error-normal);
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 2.2rem;
`;
